import numeral from 'numeral';
import PropTypes from 'prop-types';
import React from 'react';

const FormatCurrency = ({ isPriceUponRequest, price, selectedCurrency }) => {
  let formattedPrice, showForeignCurrency;
  if (
    selectedCurrency &&
    selectedCurrency.conversionRate &&
    price &&
    typeof price === 'number' &&
    !isPriceUponRequest
  ) {
    const foreignCurrencyPrice = numeral(price).multiply(selectedCurrency.conversionRate).value();
    const locale = selectedCurrency.locale || 'en-US';
    showForeignCurrency = selectedCurrency.code !== 'USD';
    if (typeof Number.prototype.toLocaleString === 'function' && toLocaleStringSupportsLocales()) {
      formattedPrice = foreignCurrencyPrice.toLocaleString(locale, {
        style:'currency',
        currency: selectedCurrency.code,
        minimumFractionDigits: 0
      });
    } else {
      formattedPrice = selectedCurrency.symbol + numeral(foreignCurrencyPrice).format('0,0[.]00');
    }
  }

  return showForeignCurrency ? (
    <span className="foreign-currency">
      {`${formattedPrice.replace(selectedCurrency.code, selectedCurrency.symbol)} ${selectedCurrency.code}`}
    </span>
  ) : null;
};

//check to see if browser supports toLocaleString with options
function toLocaleStringSupportsLocales() {
  var number = 0;
  try {
    number.toLocaleString('i');
  } catch (e) {
    return e.name === 'RangeError';
  }
  return false;
}

FormatCurrency.propTypes = {
  isPriceUponRequest: PropTypes.bool,
  price: PropTypes.number,
  selectedCurrency: PropTypes.object
};

export default FormatCurrency;



// WEBPACK FOOTER //
// ./src/components/shared/currency/format-currency.js